import React, { useState, useEffect } from "react";
import Logo from "../../src/assets/logo.png";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate


const Header = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) setShowHeader(false);
      else setShowHeader(true);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <header
      className={`bg-white shadow-md fixed top-0 left-0 w-screen max-w-none z-50 transition-transform duration-500 ${
        showHeader ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="w-full mx-auto px-2 sm:px-4 py-2 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/#")}>
          <img
            src={Logo}
            alt="BTech Mathematics"
            className="h-12 sm:h-16 w-auto"
          />
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8 px-5">
          <a href="/#" className="text-gray-800 hover:text-[#F15A29] transition">Home</a>
          <a href="/courses" className="text-gray-800 hover:text-[#F15A29] transition">Courses</a>
          <a href="/#about" className="text-gray-800 hover:text-[#F15A29] transition">About</a>
          <a
            href="/#contact"
            className="border border-[#F15A29] text-[#F15A29] px-4 py-2 rounded-full hover:bg-[#F15A29] hover:text-white transition"
          >
            Contact
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#172633] focus:outline-none z-[100]"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={30} strokeWidth={2.5} /> : <Menu size={30} strokeWidth={2.5} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`md:hidden bg-white shadow-lg overflow-hidden transition-all duration-500 ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="flex flex-col items-center gap-5 py-4">
          <a href="/#" onClick={() => setIsOpen(false)} className="text-gray-800 hover:text-[#F15A29] transition">Home</a>
          <a href="/courses" onClick={() => setIsOpen(false)} className="text-gray-800 hover:text-[#F15A29] transition">Courses</a>
          <a href="/#about" onClick={() => setIsOpen(false)} className="text-gray-800 hover:text-[#F15A29] transition">About</a>
          <a
            href="/#contact"
            onClick={() => setIsOpen(false)}
            className="border border-[#F15A29] text-[#F15A29] px-4 py-2 rounded-full hover:bg-[#F15A29] hover:text-white transition"
          >
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
